import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Mail, MessageCircle, Sparkles, Clock } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', topic: 'General question', message: '' });
  const [sent, setSent] = useState(false);
  const { toast } = useToast();

  const submit = (e) => {
    e.preventDefault();
    setSent(true);
    toast({ title: 'Message received 💝', description: 'A wedding friend will reply within 24 hours.' });
  };

  return (
    <div className="min-h-screen bg-[#FBF7F2]">
      <Navbar />
      <main className="pt-32 pb-20">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <p className="section-eyebrow text-center">Contact</p>
          <h1 className="font-serif text-4xl lg:text-6xl text-center mt-3 text-[#2A2A2A] leading-tight">
            Real humans. <span className="italic text-[#7B2C3B]">Quick replies</span>.
          </h1>
          <p className="text-center mt-5 text-[#4A4A4A] max-w-2xl mx-auto">
            We answer every message within one business day — usually within hours, weekends included. We don’t use chatbots for support.
          </p>

          <div className="mt-14 grid grid-cols-1 lg:grid-cols-5 gap-10">
            <div className="lg:col-span-2 space-y-5">
              <div className="soft-card rounded-2xl p-5">
                <Mail className="w-5 h-5 text-[#7B2C3B] mb-2" />
                <p className="font-medium text-[#2A2A2A]">Email</p>
                <a href="mailto:hello@yourweddingfriends.com" className="text-sm text-[#7B2C3B] hover:underline">hello@yourweddingfriends.com</a>
              </div>
              <div className="soft-card rounded-2xl p-5">
                <Clock className="w-5 h-5 text-[#7B2C3B] mb-2" />
                <p className="font-medium text-[#2A2A2A]">Hours</p>
                <p className="text-sm text-[#6A6A6A]">Mon–Sun, 8am–9pm ET</p>
              </div>
              <div className="soft-card rounded-2xl p-5 bg-[#F6EAE0]">
                <Sparkles className="w-5 h-5 text-[#7B2C3B] mb-2" />
                <p className="font-medium text-[#2A2A2A]">Looking for instant help?</p>
                <p className="text-sm text-[#6A6A6A] mt-1">Your AI Wedding Friend is on call 24/7 once you sign up — budget advice, vendor questions, wording suggestions, you name it.</p>
              </div>
            </div>

            <div className="lg:col-span-3 soft-card rounded-3xl p-7">
              <h3 className="font-serif text-2xl text-[#2A2A2A] mb-1 flex items-center gap-2">
                <MessageCircle className="w-5 h-5 text-[#7B2C3B]" /> Send us a message
              </h3>
              <p className="text-sm text-[#6A6A6A] mb-5">Tell us what’s going on and we’ll be in touch shortly.</p>

              {sent ? (
                <div className="p-4 rounded-xl bg-[#F6EAE0] text-[#7B2C3B] text-sm">
                  Thank you. We’ve got your message and will reply soon.
                </div>
              ) : (
                <form onSubmit={submit} className="space-y-3">
                  <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Your name" className="w-full px-4 py-3 rounded-xl border border-[#EFE3D8] bg-white text-sm focus:outline-none focus:border-[#7B2C3B]" />
                  <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" className="w-full px-4 py-3 rounded-xl border border-[#EFE3D8] bg-white text-sm focus:outline-none focus:border-[#7B2C3B]" />
                  <select value={form.topic} onChange={(e) => setForm({ ...form, topic: e.target.value })} className="w-full px-4 py-3 rounded-xl border border-[#EFE3D8] bg-white text-sm focus:outline-none focus:border-[#7B2C3B] text-[#3A3A3A]">
                    <option>General question</option>
                    <option>Billing & refunds</option>
                    <option>Bug report</option>
                    <option>Partnership</option>
                    <option>Press</option>
                  </select>
                  <textarea required rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="How can we help?" className="w-full px-4 py-3 rounded-xl border border-[#EFE3D8] bg-white text-sm focus:outline-none focus:border-[#7B2C3B] resize-none" />
                  <button type="submit" className="w-full btn-primary py-3 rounded-full text-sm font-medium">Send message</button>
                </form>
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
